module.exports = __webpack_public_path__ + "assets/img/error.7990b480.png";